import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { green, red } from "@material-ui/core/colors";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    approved: {
      color: green[700]
    },
    not_approved: {
      color: red[700]
    }
  })
);

interface Props {
  is_approved: boolean;
  reason: string;
}

const PaymentStatus = ({ is_approved, reason }: Props) => {
  const classes = useStyles();

  if (is_approved) {
    return (
      <Tooltip title={reason}>
        <IconButton>
          <CheckIcon className={classes.approved} />
        </IconButton>
      </Tooltip>
    );
  }
  return (
    <Tooltip title={reason}>
      <IconButton>
        <CloseIcon className={classes.not_approved} />
      </IconButton>
    </Tooltip>
  );
};

export default PaymentStatus;
